// When you change this file you need to rerun 'yarn start'

module.exports = Object.freeze({
  JOBS_WEBSITE: '/examples/recruitment-website',
  TRAVEL_APP: '/examples/travel-app',
  FIANCE_APP: '/examples/banking-app',
  ANIMATED_CHAT_APP: '/examples/animated-chat-app',
  DOCTOR_APP: '/examples/healthcare-app',
  HOTEL_APP: '/examples/hotel-app',
});



// WEBPACK FOOTER //
// ./src/configs/pages/examples/paths.js